import React from "react";
import Landing from "../landing/landing";
import CustomNav from "../landing/anotherNav/CustomNav";
import ResponsiveDialog from "../components/dialog.tsx";
export default function Home() {
  if (window.innerWidth < 768) {
    return (
      <>
        <ResponsiveDialog />

        <CustomNav />
        <Landing />
      </>

      // <Discover />
    );
  } else {
    return (
      <>
        <CustomNav />
        <Landing />
      </>

      // <Discover />
    );
  }
}
